import { DataField, DataFieldOption } from './DataField';
import { SequelizeTimestamps } from './Sequelize';
import { TaskStatus } from './Task';
import { UserShort } from './User';

export enum SEPPhase {
  knockout = 'knockout',
  validation = 'validation',
  initiate = 'initiate',
  design = 'design',
  implement = 'implement',
  complete = 'complete',
}

export enum SEPStatus {
  active = 'active',
  approved = 'approved',
  rejected = 'rejected',
  expired = 'expired',
  cancelled = 'cancelled',
}

export enum WORKFLOWTYPE {
  designReview = 'SEP Design Review',
  iotLabs = 'IoT Lab Approval',
  saConsultation ='Solution Architect Consultation'
}

export const SEPAgeHighlight = {
  yellow: 'SEP age highlight yellow',
  red: 'SEP age highlight red',
}

export const SEPAgeValidation = 'Validation';

export const SEPAgeKnockout = 'Draft';

export interface SEP extends SequelizeTimestamps {
  id: number;
  name?: string | null;
  description?: string | null;
  createdBy: string;
  locked: boolean;
  template: boolean;
  deletedAt?: string;
  apmID?: number | null;
  apmData?: string | null;
  phase: SEPPhase;
  status: SEPStatus;
  subscribers: string | null;
  workFlowType?: string; 
  solutionArchitectEmail?: string | null;
  itkeyManagerEmail?: string | null;
  vpEmail?: string | null;
  requestorDepartment?: string;
  validationDate?: string | null;
  enterpriceArchitectEmail?: string | null;
  completedAt?: Date;
  startedAt?: Date | null;
}

export enum NewWorkflowType {
  solutionArchitectConsultation = 'Solution Architect Consultation',
  sepDesignReview = 'SEP Design Review',
}

export const TableVisibleDataFields = [
  // Only include dataFields for the table where the column is marked as visible
  'Request Area',
  'Is this an existing application or a new application?',
  'Key Topics',
  'Business Unit'
];

export enum ScreenName {
  allSEP = 'All SEPs',
  mySEP = 'My SEPs',
}


export interface SEPSearchTask {
  id: number;
  sepID: number;
  phase: SEPPhase;
  status: TaskStatus;
  departmentID: number;
  assignedUserID: string | null;
  department?: {
    id: number;
    name: string;
  };
}

export interface SEPSearchRow extends SEP {
  /** The creator/requestor of the SEP */
  creator: UserShort;
  /** The enabled tasks for this SEP, used to derive task counts and progress */
  tasks: SEPSearchTask[];
  /** The data fields associated with the SEP */
  dataFields?: DataField[];
  /** The options for the data fields */
  dataFieldOptions?: DataFieldOption[];
  /** The number of personal notes the user has on this SEP (not including task-level notes) */
  userNotesCount: number;
  /** Mine-only summary used to order and display active tasks assigned to the current user. */
  myTodoSummary?: {
    taskCount: number;
    lastActivityAt: Date | null;
    daysSinceLastUpdate: number | null;
  };
}

export interface SEPSearchResult {
  count: number;
  seps: SEPSearchRow[];
}

export interface UpdateSEPBody {
  name?: string;
  createdBy?: string;
  description?: string | null;
  apmID?: number | null;
  apmData?:any;
  subscribers?: string | null;
  workFlowType?: string;
  vpEmail?: string,
  itkeyManagerEmail?: string,
  solutionArchitectEmail?: string,
  requestorDepartment?: string;
  validationDate?: string | null;
  completedAt?: Date | null;
  startedAt?: Date | null;
}

export interface CreateSEPBody {
  name?: string;
  description?: string | null;
  apmID?: number | null;
  subscribers?: string | null;
  workFlowType?: string;
  validationDate?: string | null;
  completedAt?: Date | null;
  startedAt?: Date | null;
}

export interface SEPBody {
  createdBy?: string;
}

export interface GetSEPResponse extends SEP {
  creator: UserShort;
}

export interface SearchParams {
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortAsc?: boolean;
  status?: string;
  phase?: string;
  assigneeId?: string;
  search?: string;
  createdBy?: string;
  mine?: boolean;
  myToDos?: boolean;
  statusFilter?: string;
  workFlowType?: string;
  createdAt?: (string | undefined)[];
  validationDate?: (string | undefined)[];
  completedAt?: (string | undefined)[];
  dataFieldColumns?: string;
  keyTopics?: string;
  filterApplied?: boolean;
}

export interface UpdateSEPStatusBody {
  sepID: number;
  status: SEPStatus;
  reason: string;
}

export type DepartmentEmailObject = {
  SolutionArchitectEmail: string;
  ITKeyManagerEmail: string;
  VPEmail: string;
  enterpriceArchitectEmail?: string;
  departmentName?: string;
};

// Admin Phase Reset Types
export interface SEPInitiatePhaseRow {
  id: number;
  name: string | null;
  phase: SEPPhase;
  status: SEPStatus;
  createdAt: string;
  creatorName: string | null;
  creatorEmail: string | null;
  validationTasksCount: number;
  initiateTasksCount: number;
}

export interface ResetToValidationBody {
  sepIDs: number[];
  taskTemplateIDs: number[];
}

export interface ResetToValidationResult {
  success: boolean;
  message: string;
  updatedSEPs: number[];
  createdTasksCount: number;
  skippedDuplicates: number;
}
